var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    y: 0.5,
    width: 22,
    height: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37355 19.9443V17.0013C8.37355 16.25 8.95783 15.641 9.67857 15.641H12.3132C12.6593 15.641 12.9913 15.7843 13.236 16.0394C13.4808 16.2945 13.6182 16.6405 13.6182 17.0013V19.9443C13.6161 20.2567 13.7336 20.557 13.9447 20.7787C14.1558 21.0003 14.443 21.125 14.7427 21.125H16.5402C17.3797 21.1273 18.1855 20.7812 18.7799 20.1633C19.3743 19.5453 19.7083 18.7062 19.7083 17.8312V9.44685C19.7083 8.73999 19.4077 8.0695 18.8876 7.61599L12.7729 2.52552C11.7092 1.63299 10.1852 1.66181 9.15328 2.59397L3.1781 7.61599C2.63335 8.05613 2.30776 8.72861 2.29167 9.44685V17.8226C2.29167 19.6465 3.7101 21.125 5.45983 21.125H7.21627C7.83863 21.125 8.34442 20.6016 8.34893 19.9529L8.37355 19.9443Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9fbbd34607859490c0cc8f1d555a553b.svg";
export { ForwardRef as ReactComponent };